import type { FC, ReactNode, Dispatch, SetStateAction } from 'react'
import { createContext, useState, useEffect } from 'react'
import type { TypeUserState } from '@/schema'
import { cookie, DY_COOKIE_SESSION, getUserDataFromCookie } from '@/utils'
import { usePathname, useRouter } from 'next/navigation'
import { checkIfPublicPath, checkIfLegalPath } from '@/proxy'

type TypeState = {
  user: TypeUserState
  setUser: Dispatch<SetStateAction<TypeUserState>>
}

const initialState: TypeState = {
  user: null,
  setUser: () => { },
}

export const SessionContext = createContext<TypeState | null>(initialState)

interface Props {
  children: ReactNode
}

// let cookieChecked = false
export const SessionProvider: FC<Props> = ({ children }) => {
  const [user, setUser] = useState<TypeUserState>(undefined)
  const { push } = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    const userCookieData = getUserDataFromCookie(cookie.get(DY_COOKIE_SESSION))

    if (!userCookieData) {
      if (!checkIfPublicPath(pathname) && !checkIfLegalPath(pathname)) push('/login')
    } else {
      // Update cookieDate from the API in case new vets or users are added
      // PENDING
      const localStorageVets = localStorage.getItem(`dy_virbac_user_${userCookieData.user.id}`)
      const vets = JSON.parse((localStorageVets && localStorageVets !== 'undefined') ? localStorageVets : null)
      setUser({ ...userCookieData.user, vets: vets, token: userCookieData.token })
    }

    // cookieChecked = true
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <SessionContext.Provider value={{ user, setUser }}>{children}</SessionContext.Provider>
}
